import { render, staticRenderFns } from "./iframeCommon.vue?vue&type=template&id=b6500460&scoped=true&"
import script from "./iframeCommon.vue?vue&type=script&lang=js&"
export * from "./iframeCommon.vue?vue&type=script&lang=js&"
import style0 from "./iframeCommon.vue?vue&type=style&index=0&id=b6500460&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6500460",
  null
  
)

export default component.exports